import React, {Component} from 'react';

import {Button, Card, Row, Tooltip, Drawer, Popconfirm, message} from 'antd';
import TableComponent from '@common/components/table';
import queryString from 'query-string';
import ModelServices from '../services/User';

import moment from 'moment';
import FileSaver from 'file-saver';
import FilterForm from '@common/components/filterForm';
import _ from '@common/utils/formatters/_';
import ModelCreate from '../forms/Create';


const model = component => {
  return {
    with_server_pagination: true, // metti paginazione lato server
    columns:[
      {
        title: '',
        dataIndex: '',
        sorter: false,
        key: 'actions',
        width: '60px',
        render: element => <div style={{width: 60}}>
          <Tooltip placement="top" title="Visualizza dettaglio dell'ispettore">
            <Button className="m2w" size="small" shape="circle" icon={"eye"} onClick={() => component.props.history.push(component.getUserUrl(element))} />
          </Tooltip>
            <Tooltip placement="top" title="Disabilita">
              <Popconfirm placement="leftTop" title="Sicuro di voler disabilitare questo elemento?" onConfirm={() => component.removeRole(element.id)} okText="Si" cancelText="No">
                <Button className="m2w" size="small" shape="circle" icon="user-delete" />
              </Popconfirm>
            </Tooltip>         
        </div>,
      },
      {
        title: 'Nome',
        dataIndex: '',
        sorter: true,
        key: 'nome',
        render: element => <div>{element.anagrafica?.nome}</div>,
      },
      {
        title: 'Cognome',
        dataIndex: '',
        sorter: true,
        key: 'cognome',
        render: element => <div>{element.anagrafica?.cognome}</div>,
      },
      {
        title: 'Codice fiscale',
        dataIndex: '',
        sorter: true,
        key: 'cf',
        render: element => <div>{element.anagrafica?.cf}</div>,
      },
      {
        title: 'Email',
        dataIndex: '',// dataIndex lo lasciamo sempre vuoto per avere maggiore libertà sui campi
        sorter: true,
        key: 'email',
        render: element => <div>{element.email}</div>,
      },
      {
        title: 'Ultimo aggiornamento',
        dataIndex: '',
        sorter: true,
        key: 'updated_at',
        render: element => `${moment(element.updated_at,'X').format('DD/MM/YYYY HH:mm')}`,
      },
    ]
  }
}


export default class ListIspettori extends Component {

  default_order = 'cognome'

  state = {
    loading: false,
    open_drawer: false,
    editing_id: null,
    data: {
      total: 0,
      current: 1,
      data: []
    }
  }

  componentDidMount () {
    this.callAndUpdate(this.props)
  }

  getUserUrl(item) {
    return "/ispettore/" + item.id
  }

  getBaseUrl() {
    return this.props.base_url ? this.props.base_url : "/ispettore";
  }

  setDefaultSearchParams(str) {
    return str
  }

  /**
   * Carica dati
   * @param  {[type]} props [description]
   * @return {[type]}       [description]
   */
  callAndUpdate(props) {
    let { params, pager } = _.getFilterParam(props, this.default_order);
    params = this.setDefaultSearchParams(params);
    this.setState({ loading: true });
    ModelServices.listIspettori(params, (res) => {
      let data = _.getResponse(res);
      this.setState({
        loading: false,
        data: data
      }, () => this.refs.table_component.updateTableData(
        data.data,
        data.current,
        data.total,
        pager)
      );

    }, () => {
      this.setState({ loading: false });
    })
  }

  /**
   * Se cambia la stringa aggiorna
   * @param  {[type]} newProps [description]
   * @return {[type]}          [description]
   */
  componentDidUpdate(prevProps, prevState) {
    if (prevProps.location.search !== this.props.location.search) {
      this.callAndUpdate(this.props.location.search);
    }
  }

  getFilterModel() {
    return  {
      layout: 'vertical',
      multistep: false,
      rows: [
        {
          cols: [
            {
              items: [
                {
                  type: 'input',
                  label: 'Nome',
                  type_string: 'text', // field type
                  name: 'nome',
                }
              ]
            },
            {
              items: [
                {
                  type: 'input',
                  label: 'Cognome',
                  type_string: 'text', // field type
                  name: 'cognome',
                }
              ]
            },
            {
              items: [
                {
                  type: 'input',
                  label: 'Email',
                  type_string: 'email', // field type
                  name: 'email',
                }
              ]
            }
          ]
        },
        {
          cols: [
            {
              items: [
                {
                  name: 'submit',
                  type: 'submit',
                  text: 'Cerca',
                  btn_type: 'primary'
                }
              ]
            }
          ]
        },
      ]
    }
  }

  /**
   * Ricarica dopo update
   * @return {[type]} [description]
   */
  refresh(){
    this.setState({ open_drawer: false });
    this.callAndUpdate(this.props)
  }

  /**
   * Chiamato da sort in tabella
   * @param  {[type]} obj [description]
   * @return {[type]}     [description]
   */
  updateQueryStr(obj) {
    _.formatSortChange(this.props, this.getBaseUrl(), obj);
  }

  /**
   * Chiamato da tabella
   * @param  {[type]} id [description]
   * @return {[type]}    [description]
   */
  async updateRecord(id) {
    await this.setState({editing_id: id});
    this.setState({open_drawer: true});
  }

  /**
   * Chiamato da tabella
   * @param  {[type]} id [description]
   * @return {[type]}    [description]
   */
  deleteRecord(id) {
    ModelServices.delete(id, () => this.refresh(), () => null)
  }


  /**
   * Record aggiornato in form
   * @return {[type]} [description]
   */
  updatedRecord() {
    this.setState({open_drawer: false, editing_id: false});
    this.callAndUpdate(this.props);
  }

  removeRole(id) {
    this.setState({ loading: true });
    ModelServices.removeRole(id, {role: 'IspettoreAccreditamento'}, () => {
      message.success("Operazione effettuata con successo")
      this.refresh()
    }
      , () => this.setState({ loading: false }))
  }

  render () {
    return (
      <div>
        <FilterForm
          formLayout={this.getFilterModel()}
          base_url={this.getBaseUrl()}
          search={this.props.location.search}
          history={this.props.history}
        />
        <Card
          className="shadow no-pad"
          bordered={false}
        >

          <Row type="flex" justify="start" className="m10h">
            <div className="m5h m5w">
              <Button className="m5h bg-green" icon="plus" onClick={() => this.setState({ open_drawer: true })} loading={this.state.loading}>Inserisci Addetto al controllo</Button>
            </div>
            <div className="m5h m5w">
              <Button className="m5h bg-green" icon="plus" onClick={() => {
                 if (!this.state.loading) {
                  this.setState({ loading: true}, () => {
                    let params = queryString.parse(this.props.location.search);
                    ModelServices.export({ ...params,
                      role: 'IspettoreAccreditamento'
                    }, (res) => {
                      const today = new Date();
                      const month = today.getMonth() + 1;
                      const year = today.getFullYear();
                      const date = today.getDate();
                      const hour = ('0' + today.getHours()).slice(-2);
                      const minu = ('0' + today.getMinutes()).slice(-2);
                      let nome_file = `elenco_regionale_ispettori_${date}${month}${year}_${hour}${minu}.csv`;
                      // https://cb.schema31.it/cb/issue/446628
                      // const _blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                         const _blob = new Blob([res.data], { type: 'text/x-csv' });
                      FileSaver.saveAs(_blob, nome_file);
                      this.setState({ loading: false });
                    }, () => this.setState({ loading: false }));
                    })
                }
              }
              } loading={this.state.loading}>Esporta elenco</Button>
            </div>
          </Row>
          <Drawer
            title="Inserisci un nuovo Addetto al controllo"
            width={720}
            placement="right"
            onClose={() => this.setState({ open_drawer: false })}
            maskClosable={true}
            destroyOnClose={true}
            visible={this.state.open_drawer}
            style={{
              overflow: 'auto',
            }}
          >
            {this.state.open_drawer &&
              <ModelCreate
                {...this.props}
                role={'IspettoreAccreditamento'}
                onCreate={() => this.refresh()}
                infoIspettore={true}
                noPassword={true}
              />
            }

          </Drawer>

          <TableComponent
            data={this.state.data} model={(this.props.table_model) ? this.props.table_model(this) : model(this)}
            table_props={{ rowKey: 'id' }}
            size="medium"
            ref="table_component"
            loading={this.state.loading}
            with_server_pagination={true}
            updatePage={(newPage) => this.updateQueryStr({ page: newPage })}
            updateSort={(sort) => this.updateQueryStr({ sort: sort })}
          />
        </Card>
      </div>
    );
  }
}

